/* We call product component to the rows or the products to buy we are displaying on the website
We also divide it and organize. As we create a product.js file we also create a Product.css file
Notice how we have the div className for product__info
The title with <p> code
the className for product__price
dollar sign with <small> and amount with <strong> That's the way to do it  */
import React from "react";
import "./Product.css";
import { useStateValue } from "./StateProvider";

function Product({ id, title, image, price, rating }) {

        const [{ basket }, dispatch] = useStateValue(); 
        

        const addToBasket  = () => {
            // dispathes the item into the data layer
            dispatch({
                type: 'ADD_TO_BASKET',
                item: {
                    id: id,
                    title: title,
                    image: image,
                    price: price,
                    rating: rating,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                },

        });

    };

    return (
        <div className="product">
                <div className="product__info">
                    <p>{title}</p>
                    <p className="product__price">
                        <small>$</small>
                        <strong>{price}</strong>
                        </p>
                        <div className="product__rating">
                            {Array(rating).fill().map((_, i) => (
                             <p>🌟</p>   
                            ))}
                            
                </div>
        </div>
        <img 
            src={image} 
            alt="" 
            />

            <button onClick={addToBasket}>Add to Basket</button>
    </div>
    );
}

export default Product;
